module.exports = __webpack_public_path__ + "static/media/darjeeling-biryani-800x533.de694f02.jpg";